/**
 * Due-session round summary helpers.
 * A topic leaves Due only when recalled today; "No" keeps it due.
 */

import { isRecalledToday } from '../../store/workspacesSlice';

export { isRecalledToday };

/**
 * @param {{
 *   doneIds: Iterable<string>,
 *   topics?: Array<{ id: string, last_recalled_at?: string|null }>,
 *   remainingDueCount: number,
 * }} args
 */
export const computeDueRoundSummary = ({
  doneIds,
  topics = [],
  remainingDueCount = 0,
}) => {
  const topicsById = new Map((topics || []).map((topic) => [topic.id, topic]));
  const doneList = [...(doneIds || [])];
  const total = doneList.length;

  const notRecalledIds = doneList.filter((id) => {
    const topic = topicsById.get(id);
    return !isRecalledToday(topic?.last_recalled_at);
  });

  const recalledCount = total - notRecalledIds.length;
  const remaining = Math.max(0, remainingDueCount);
  const untested = Math.max(0, remaining - notRecalledIds.length);

  return {
    total,
    recalledCount,
    notRecalledIds,
    notRecalled: notRecalledIds.length,
    remaining,
    untested,
  };
};

export const formatItemCount = (count) =>
  `${count} item${count === 1 ? '' : 's'}`;
